// components/WatchPurchaseGrid.js
import React from 'react';
import styles from './WatchPurchaseGrid.module.scss';
import {useNavigate} from "react-router-dom";

const WatchPurchaseGrid7 = () => {
  const watchBrands = [
    {
      name: "Antikvitetni nakit od zlata i srebra",
      image: "assets/images/ugarski.jpg",
      models: ["Carski, kraljevski, austrougarski, jugoslovenski i strani"]
    },
    {
      name: "Porodične kolekcije nakita",
      image: "assets/images/collection.jpg",
      models: [""]
    },
    {
      name: "Neobičan i ručno rađen nakit",
      image: "assets/images/neobican.webp",
      models: [""]
    },
    {
      name: "Komadi sa dragim kamenjem",
      image: "assets/images/dijamant.png",
      models: ["Dijamanti, safiri, rubini, smaragdi..."]
    }
  ];

  const navigate = useNavigate();

  const handleClick = (brandName) => {
    const urlName = brandName.toLowerCase().replace(/\s+/g, "-"); // "Audemars Piguet" -> "audemars-piguet"
    window.location.href = `/brands/${urlName}`;
  };

  return (
    <section className={styles.watchPurchaseGrid}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>💍 Stari nakit</h2>

        <div className={styles.grid}>
          {watchBrands.map((brand, index) => (
            <div key={index} className={styles.brandCard}>
              <div className={styles.brandHeader}>
                <h3>OTKUPLJUJEMO</h3>
                <h4>{brand.name}</h4>
                {/*<p>satova</p>*/}
              </div>

              <div className={styles.brandImage}>
                <img src={brand.image} alt={brand.name} />
              </div>

              <div className={styles.models}>
                {brand.models.map((model, idx) => (
                  (
                    idx === brand.models.length - 1 ?
                      <span>{model}</span>
                      :
                      <span>{model}, </span>
                  )
                ))}
              </div>

              <button className={styles.inquiryBtn} onClick={() => handleClick(brand.name)}>Saznaj više</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WatchPurchaseGrid7;